export const CREATE_PASSWORD_FORM_REQUIREMENTS_ITEMS = [
  'Auth.CreatePasswordRequirementAtLeast8CharactersKey',
  'Auth.CreatePasswordRequirementUpperCaseLettersKey',
  'Auth.CreatePasswordRequirementLowerCaseLettersKey',
  'Auth.CreatePasswordRequirementAtLeastOneNumeralKey',
  'Auth.CreatePasswordRequirementOneSymbolKey',
]
